/**
 * Pure helpers for the article carousel's windowing. Kept free of React/DOM so
 * the wrap-around logic can be unit-tested in isolation.
 */

/** Index after advancing one step forward, wrapping past the end to the start. */
export const nextIndex = (current: number, length: number): number =>
  length <= 0 ? 0 : (current + 1) % length

/** Index after stepping one back, wrapping before the start to the end. */
export const prevIndex = (current: number, length: number): number =>
  length <= 0 ? 0 : (current - 1 + length) % length

/**
 * The `count` items visible starting at `startIndex`, wrapping around the end
 * of the list. Never returns more items than the list holds.
 */
export const visibleWindow = <T>(items: T[], startIndex: number, count: number): T[] => {
  if (items.length === 0) return []
  const size = Math.min(count, items.length)
  return Array.from({ length: size }, (_, i) => items[(startIndex + i) % items.length])
}
